import { JSXElement, mergeProps, Show } from 'solid-js';
import { Title } from '@solidjs/meta';
import { getLocalizedString } from '~/i18n/utils.ts';
import { useIntl } from '@cookbook/solid-intl';

type AppTitleProps = {
  title?: string;
};

export default function AppTitle(props: AppTitleProps): JSXElement {
  const merged = mergeProps({}, props);
  const intl = useIntl();
  return (
    <Title>
      <Show
        when={merged.title}
        fallback={getLocalizedString('app_title.default', { intl })}
      >
        {getLocalizedString('app_title.page_title_suffix', {
          intl,
          pageTitle: merged.title
        })}
      </Show>
    </Title>
  );
}
